import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { DeviceUnloadDevices, UnloadableDevicesUnloadDevices } from '../../../models/unload-devices';
import { Observable } from 'rxjs';
import { ServerRootService } from '../../../utils/routing/serverroot.service';

export abstract class UnloadDeviceBaseService extends ServerRootService {
    protected readonly httpClient = inject(HttpClient);

    getAvailableDevices(idExamination: string): Observable<DeviceUnloadDevices[]> {
        return this.httpClient.post<DeviceUnloadDevices[]>(
            this.getServerRoot() + '/UnloadDeviceCore/GetAvailableDevices',
            `"${idExamination}"`,
            this.buildOptions(),
        );
    }

    getUnloadedDevices(idExamination: string): Observable<UnloadableDevicesUnloadDevices[]> {
        return this.httpClient.post<UnloadableDevicesUnloadDevices[]>(
            this.getServerRoot() + '/UnloadDeviceCore/GetUnloadedDevices',
            `"${idExamination}"`,
            this.buildOptions(),
        );
    }

    unloadDevices(params: UnloadableDevicesUnloadDevices): Observable<void> {
        return this.httpClient.post<void>(
            this.getServerRoot() + '/UnloadDevice/UnloadDevices',
            params,
            this.buildOptions(),
        );
    }
}
